// @internal
export function toBoolean(value) {
  return value != null && `${value}` !== 'false';
}
